import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Users, ChevronDown, ChevronUp } from "lucide-react";
import api from "@/lib/api";

export function PicWorkload({ onPick }) {
  const [open, setOpen] = useState(true);
  const q = useQuery({ queryKey: ["meeting-pic-workload"], queryFn: async () => (await api.get("/meeting/pic-workload")).data });
  const d = q.data;
  if (!d || !d.rows.length) return null;
  return (
    <section className="pp-card p-4" data-testid="pic-workload">
      <button className="flex w-full items-center justify-between gap-2 text-left" onClick={() => setOpen((o) => !o)} data-testid="pic-workload-toggle">
        <div className="pp-label flex items-center gap-2"><Users size={14} /> PIC workload · {d.rows.length} PIC(s) · {d.total_open} open point(s) · <span className={d.total_overdue ? "text-rose-700" : ""}>{d.total_overdue} overdue</span></div>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>
      {open && <div className="mt-3 space-y-1.5">
        {d.rows.map((r) => {
          const w = d.max_load ? Math.round((r.total / d.max_load) * 100) : 0; const ow = r.total ? Math.round((r.overdue / r.total) * 100) : 0;
          return (
            <div key={r.pic} className="grid grid-cols-[minmax(120px,180px)_1fr_auto] items-center gap-3 text-xs" data-testid={`pic-row-${r.pic}`}>
              <button className="truncate text-left font-semibold text-slate-800 hover:text-blue-700 hover:underline" title={`Show ${r.pic}'s points`} onClick={() => onPick?.(r.pic)} data-testid={`pic-pick-${r.pic}`}>{r.pic}</button>
              <div className="relative h-5 w-full overflow-hidden rounded bg-slate-100" title={`${r.total} open · ${r.overdue} overdue`}>
                <div className="absolute inset-y-0 left-0 bg-blue-200" style={{ width: `${w}%` }} />
                <div className="absolute inset-y-0 left-0 bg-rose-400/80" style={{ width: `${(w * ow) / 100}%` }} />
                <div className="absolute inset-0 flex items-center gap-2 px-2 font-mono text-[10px] text-slate-700">
                  <b>{r.total}</b> open{r.in_progress ? ` (${r.in_progress} in progress)` : ""}{r.overdue ? <span className="font-bold text-rose-800" data-testid={`pic-overdue-${r.pic}`}> · {r.overdue} overdue{r.max_overdue_days ? ` · oldest ${r.max_overdue_days}d` : ""}</span> : null}{r.high ? ` · ${r.high} high` : ""}
                </div>
              </div>
              <div className="hidden sm:flex gap-1">{r.categories.map(([c, n]) => <span key={c} className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] text-slate-600">{c} {n}</span>)}</div>
            </div>
          );
        })}
        <p className="pt-1 text-[11px] text-slate-400">Bar length = open points relative to the busiest PIC; red portion = overdue. Click a name to filter the list below.</p>
      </div>}
    </section>
  );
}
